<template>
  <div id="Services_page">

    <!-- <canvas></canvas> -->
    <main id="main" data-page-id="home">
      <section class="innerpage_header" data-scroll-section="sec4">
        <video class="bg_innerpages" autoplay muted loop src="../../../assets/video/services.mp4"></video>
        <div class="innerpage_header_textbox">
          <h1> Our Sectors</h1>
        </div>

        <a class="next_slide" v-on:click="NextSlide()">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
            y="0px" width="60px" height="60px" viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;"
            xml:space="preserve">

            <defs>
            </defs>
            <path class="st0" d="M60,30C60,13.5,46.5,0,30,0S0,13.5,0,30s13.5,30,30,30S60,46.5,60,30z M29.2,45.6l-15-22
            C14.1,23.4,14,23.2,14,23c0-0.2,0-0.3,0.1-0.5c0.2-0.3,0.5-0.5,0.9-0.5h30c0.4,0,0.7,0.2,0.9,0.5c0.2,0.3,0.2,0.7-0.1,1l-15,22
            C30.6,45.8,30.3,46,30,46S29.4,45.8,29.2,45.6z" />
          </svg>

        </a>
      </section>

      <section class="services s2" data-scroll-section="sec4">
        <div class="container">
          <div class="row " :v-if="sectors">
            <div class="col-md-4" v-for="(item,index) in sectors" :key="index" >
              <div class="grid_items">
                <img class="sectors__index__item" :src="'./static/sectors/' + item.image" >
                <h4>
                  {{item.title}}
                </h4>
                <p>
                </p>
                 <p>
                  {{item.desc}}
                 </p>
                <br>
                <router-link :to="'/sectors/'+item.slug" class="button button--transparent pulse">
                  Read More
                </router-link>
              </div>
            </div>

           


              


          </div>

        </div>
      </section>
 
      <section class="started-section" >
        <video class="bg_innerpages" autoplay muted loop src="../../../assets/video/services.mp4"></video>

        <div class="container row started__container">
          <div class="content__left">
            <div class="js-content-block text-block">
              <h2 class="title md-title">MI</h2>
              <p class="subtitle">this is where imagination meets innovation.</p>
            </div>
          </div>
          <div class="content__right">
            <div class="buttons__wrap">
              <router-link class="button button--white-hover-trans pulse" to="/contact">Contact</router-link>
              <a href="https://web.mobilityintel.com" class="button button--transparent pulse">get started</a>
            </div>
          </div>
        </div>
      </section>

   
      <section class=" o-eric-progress e-scrol">
        <div class="c-eric-progress-container">
          <div class="c-eric-progress">
            <div class="c-eric-progress__counter">
              <div class="c-eric-progress__counter-zero">0</div>
              <div class="c-eric-progress__counter-item">

              </div>
            </div>
            <div class="c-eric-progress-el">

            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
  import global from '@/mixins/global';
  import dataSectors from '@/assets/data/sectors'

  export default {
    name: 'Services_page',
    data() {
      return {
          sectors:undefined
      };
    },
    // components: { Header},
    mixins: [global],
    metaInfo: {
      title: 'Services',
    },
    methods: {
      NextSlide() {
        var val = $("section.s2").offset().top;
        console.log("data-scroll =", val);
        window.scrollTo({
          top: val,
          behavior: 'smooth'
        });
      }
    },
    mounted() {
      this.sectors = dataSectors.data;
      console.log("orginal component");
    },
  };

</script>
<style lang="scss" scoped>
  // @import("@fancyapps/fancybox/")
  .st0 {
    fill: #24AD60;
  }

  .st1 {
    fill: #FFFFFF;
  }

  .st2 {
    display: none;
  }

  .cls-1 {
    fill: #ffffff;
  }

  a.next_slide {
    cursor: pointer;
    position: absolute;
    bottom: 0;
    transform: translateX(-50%);
    left: 50%;
  }

  a.next_slide svg {
    max-width: 32px;
    cursor: pointer;
  }

  .st0 {
    fill: #FFFFFF;
  }



  .s0t0 {
    fill: none;
  }

  .s0t1 {
    fill: #080117;
  }

  .s0t2 {
    fill-opacity: 0;
    stroke: #FFFFFF;
    stroke-width: 2;
  }

  .s0t3 {
    fill-opacity: 0;
    stroke: #009245;
    stroke-width: 2;
  }

  .grid_items {
    text-align: left;
    padding: 77px 33px;
    color: white;
  }

  .grid_items h4 {
    text-transform: uppercase;
    font-size: 25px;
    font-weight: 300;
    padding: 0;
    margin: 0;
    margin-top: 8px;
  }

  a.next_slide {
    z-index: 5;
  }

img.sectors__index__item {
    height: 95px;
    width: 82px;
}

</style>



// WEBPACK FOOTER //
// src/components/Sectors/index.vue